import React from 'react';
import ManageConversations from '../../../conversation/containers/manage-conversations/ManageConversations';
import SimplePageLayout from '../../../layouts/simple-page-layout/SimplePageLayout';

const CallCenterMessageCenterPage: React.FC = () => (
  <SimplePageLayout fitMaxAvailableHeight>
    <ManageConversations />
  </SimplePageLayout>
);

export default CallCenterMessageCenterPage;
